import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const searchPolicyholders = async ({ searchText, customerType = null }) => {
  const response = await HttpClient.get(`/${Env.server.mode}/clients`, {
    requestType: 'clientsByUserId',
    searchText: searchText,
    customerType,
  });

  return response.data?.data?.items;
};

export const searchPolicyholdersByLicensePlate = async ({ licensePlate, customerType = null }) => {
  const response = await HttpClient.get(`/${Env.server.mode}/clients`, {
    requestType: 'clientsByVehicleNumber',
    vehicleNumber: licensePlate,
    customerType
  });

  return response.data?.data?.items;
};

export const fetchPolicyholder = async (id) => {
  const response = await HttpClient.get(`/${Env.server.mode}/clients/${id}`, {});
  return response.data?.data;
};
